import { useEffect, useState } from "react";

const FALLBACK_PX_PER_REM = 16;

function readPxPerRem(): number {
  if (typeof window === "undefined") return FALLBACK_PX_PER_REM;
  const size = parseFloat(getComputedStyle(document.documentElement).fontSize);
  return Number.isFinite(size) && size > 0 ? size : FALLBACK_PX_PER_REM;
}

/**
 * 1rem 이 지금 몇 px 인가.
 *
 * 이 앱은 루트 폰트가 해상도에 따라 커진다 — FHD 100% · QHD 131.25% · 4K 200%
 * (`globals.css` 의 단계식 미디어쿼리). 그래서 rem 로 잰 임계값은 관제 PC 에서
 * 자동으로 넉넉해진다. px 로 박으면 4K 에서 실제보다 좁다고 판단한다.
 *
 * CSS 로 끝나는 곳(Tailwind 클래스)에는 필요 없다. **JS 가 px 숫자를 다뤄야 할 때**만
 * 쓴다 — 예: ResizeObserver 로 잰 폭과 rem 임계값을 비교할 때, 캔버스/SVG 좌표 계산.
 */
export function useRemPx(): number {
  const [pxPerRem, setPxPerRem] = useState(readPxPerRem);

  useEffect(() => {
    // 루트 폰트는 폭·높이 미디어쿼리로만 바뀐다 — resize 로 충분하다.
    const onResize = () => setPxPerRem(readPxPerRem());
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return pxPerRem;
}
